import { render } from "./Policies.vue?vue&type=template&id=2b9bf98e&scoped=true"
import script from "./Policies.vue?vue&type=script&lang=js"
export * from "./Policies.vue?vue&type=script&lang=js"

import "./Policies.vue?vue&type=style&index=0&id=2b9bf98e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2b9bf98e"

export default script